var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ButtonLink',{attrs:{"color":"red","icon":"trash-alt","leading-icon":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('remove')}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }